// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__ABp18","errorLogs":"EditorFooter_errorLogs__lCbY6"};